import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { UnassignedStudiesQuery, UnassignedStudiesQueryVariables } from '@/shared/api';
import UNASSIGNED_STUDIES_QUERY from '../queries/unassignedStudies';

/**
 * Loads clinic studies that still have no device assigned. Runs UNASSIGNED_STUDIES_QUERY and throws the first GraphQL error message when clinicStudies is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The unassigned clinic studies page.
 */
const fetchUnassignedStudies = async (
  filter: UnassignedStudiesQueryVariables['filter'],
  limit = 10,
): Promise<UnassignedStudiesQuery['clinicStudies']> => {
  const client = createClient();
  const result = await client.query<UnassignedStudiesQuery, UnassignedStudiesQueryVariables>({
    query: UNASSIGNED_STUDIES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = result;
  const { clinicStudies } = data;
  if (_.isNil(clinicStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicStudies;
};

export default fetchUnassignedStudies;
